import React from 'react';
import { Button } from '../../../../components/ui/Button';
import type { OrganizationPixKey } from '../../../../domain/pix/types';
import { maskPixKey } from '../../../../domain/pix/maskPixKey';
import { PIX_TYPE_OPTIONS } from '../../../settings/pix/components/PixKeyFormFields';

function getTypeLabel(type: OrganizationPixKey['pixType']): string {
    return PIX_TYPE_OPTIONS.find((option) => option.value === type)?.label ?? type;
}

interface ChatPixSavedCardProps {
    savedKey: OrganizationPixKey;
    canManage: boolean;
    isSubmitting: boolean;
    onSend: () => void;
    onEdit: () => void;
}

export const ChatPixSavedCard: React.FC<ChatPixSavedCardProps> = ({
    savedKey,
    canManage,
    isSubmitting,
    onSend,
    onEdit,
}) => (
    <div className="space-y-4">
        <div>
            <p className="text-sm text-secondary">Titular</p>
            <p className="font-medium text-primary">{savedKey.pixName}</p>
        </div>
        <div>
            <p className="text-sm text-secondary">Tipo</p>
            <p className="text-primary">{getTypeLabel(savedKey.pixType)}</p>
        </div>
        <div>
            <p className="text-sm text-secondary">Chave</p>
            <p className="font-mono text-primary">{maskPixKey(savedKey.pixKey)}</p>
        </div>
        <div className="flex flex-wrap gap-2 pt-2">
            {canManage && (
                <Button type="button" variant="outline" onClick={onEdit} disabled={isSubmitting}>
                    Editar
                </Button>
            )}
            <Button type="button" onClick={onSend} disabled={isSubmitting}>
                {isSubmitting ? 'Enviando...' : 'Enviar'}
            </Button>
        </div>
    </div>
);
